import { setDefaultOptions } from 'date-fns';
import { enUS } from 'date-fns/locale/en-US';
import { es, zhCN, zhTW, arSA, ru, uz } from 'date-fns/locale';
import type { Locale as DateLocale } from 'date-fns';
import { watch } from 'vue';
import type { Composer, Locale } from 'vue-i18n';
import { defineNuxtPlugin } from '#app';

export default defineNuxtPlugin((nuxtApp) => {
  const $i18n = nuxtApp.$i18n as Composer;

  const locales: Record<Locale, DateLocale> & Record<string, DateLocale> = {
    'ar-SA': arSA,
    'es-ES': es,
    'en-US': enUS,
    'zh-CN': zhCN,
    'zh-TW': zhTW,
    'ru-RU': ru,
    'uz-UZ': uz,
  };

  function loadDateFnsLocale(locale: Locale) {
    const loadedLocale = locales[locale] || enUS;
    setDefaultOptions({ locale: loadedLocale });
  }

  watch($i18n.locale, (newLocale) => {
    loadDateFnsLocale(newLocale);
  }, { immediate: true });
});
